"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.render = exports.setOpen = exports.get = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
// import { stevieTexts2 } from '@uiParts/stevieTexts2-sidecar'
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(true);
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 0;
    var th = 0;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiGame);
    canvas.autoOffset = false;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {});
    return obj;
};
var setOpen = function (isOpen) {
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
};
exports.setOpen = setOpen;
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var x = gb.width - 200;
    var y = 20;
    var w = 500;
    var h = 300;
    var sy = y;
    var sx = x;
    var addText = function (text, ox, oy) {
        if (ox === void 0) { ox = 0; }
        if (oy === void 0) { oy = 0; }
        // let t = voyageUiCanvas.addText(obj, text, x + ox, y + oy, 3)
        // stevieTexts2.setWrapWidth(t, w - 60)
        diveFont_sidecar_1.diveFont.writeAbsolute(x + ox, y + oy, text, 0.5, diveColors_1.diveColors.pureWhite);
        y += 20;
        // return t
    };
    var addSpacer = function () {
        y += 30;
    };
    addText('WS: ' +
        websockets_sidecar_1.websockets.getConnectionStatus() +
        ' (' +
        (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost() ? 'Host' : 'Client') +
        ')');
    if (websockets_sidecar_1.websockets.getConnectionStatus() === 'Open') {
        addText('Game: ' + websockets_sidecar_1.websockets.getChannel());
        addText('Id: ' +
            voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId() +
            ' - ' +
            voyageWebsockets_sidecar_1.voyageWebsockets.getMultiName());
        var ping = voyageWebsockets_sidecar_1.voyageWebsockets.getPingTime();
        if (ping >= 999) {
            ping = '-';
        }
        else {
            ping = ping + ' ms';
        }
        addText('Ping: ' + ping);
    }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
exports.render = render;
var update = function () {
    var obj = get();
    if (obj.isOpen) {
        voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
        exports.render();
    }
};
exports.update = update;
